import { Injectable, Inject } from '@angular/core';
import { Http, Response, ResponseContentType, RequestOptions, Headers } from '@angular/http';
import { Observable, of, throwError } from 'rxjs';
import { Router } from '@angular/router';
//import 'rxjs/add/operator/map';
//import 'rxjs/add/operator/catch';
//import 'rxjs/add/observable/throw';
import * as moment from "moment";
import { map, filter, catchError, mergeMap } from 'rxjs/operators';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { debug } from 'util';

@Injectable()
export class AuthService {

  constructor(private _http: HttpClient, @Inject('BASE_URL') baseUrl: string) {

  }

  blrlogin(user: string, password: string): Observable<any> {
    debugger;
    const _formData = new FormData();
    _formData.append('UserName', user);
    _formData.append('Password', password);
    _formData.append('AuthenticationSystem', 'WA');
    return this._http.post<any>('https://auth.blr.com/account/login?origin=flsa.smarthrmanager.com&isSecure=true', _formData)      
  }

  login(user: string, password: string): Promise<boolean> {
    if (user === "Admin" && password === "Admin") {
      return Promise.resolve(true);
    } else {
      return Promise.resolve(false);
    }
  }

  errorHandler(error: Response | any) {
    console.log(error);
    alert(error);
    console.error(error.message || error);
    return Observable.throw(error);
  }
}
